type AccordionButton = HTMLButtonElement;
type AccordionPanel = HTMLElement;

const SELECTOR_BUTTON = '.bloc-indicateurs__accordion-button';
const CLASS_OPEN = 'is-open';

function getControlledPanel(button: AccordionButton): AccordionPanel | null {
	const panelId = button.getAttribute('aria-controls');

	if (!panelId) {
		return null;
	}

	return document.getElementById(panelId);
}

function setAccordionState(
	button: AccordionButton,
	panel: AccordionPanel,
	isOpen: boolean
): void {
	const item = button.closest<HTMLElement>('.bloc-indicateurs__accordion-item');

	button.setAttribute('aria-expanded', String(isOpen));

	if (item) {
		item.classList.toggle(CLASS_OPEN, isOpen);
	}

	if (isOpen) {
		panel.removeAttribute('hidden');
	} else {
		panel.setAttribute('hidden', '');
	}
}

function toggleAccordion(button: AccordionButton): void {
	const panel = getControlledPanel(button);

	if (!panel) {
		return;
	}

	const isOpen = button.getAttribute('aria-expanded') === 'true';

	setAccordionState(button, panel, !isOpen);
}

export function initBlocIndicateurs(): void {
	const buttons = document.querySelectorAll<AccordionButton>(SELECTOR_BUTTON);

	buttons.forEach((button) => {
		const panel = getControlledPanel(button);

		if (!panel) {
			return;
		}

		const isOpen = button.getAttribute('aria-expanded') === 'true';

		setAccordionState(button, panel, isOpen);

		button.addEventListener('click', () => {
			toggleAccordion(button);
		});
	});
}
